import MainLayout from '../layouts/main';
import VoicesListContainer from './container';

function VoicesPage() {
  return (
    <MainLayout>
      <VoicesListContainer/>
    </MainLayout>
  );
}

export default VoicesPage;
